import { TV_NETWORKS } from "@/data/content";

// Rejilla de televisoras (imágenes fake reemplazables) — "Transmitido en TV abierta por"
export const TVNetworks = () => (
  <div className="flex flex-wrap gap-2.5" data-testid="tv-networks">
    {TV_NETWORKS.map((tv, i) => (
      <div
        key={tv.n}
        data-testid={`tv-network-${i + 1}`}
        className="group w-[104px] overflow-hidden rounded-xl bg-white/5 ring-1 ring-white/10 transition-all duration-300 hover:-translate-y-0.5 hover:ring-white/25"
      >
        <div className="aspect-[3/2] overflow-hidden">
          <img
            src={tv.img}
            alt={`${tv.name} — televisora`}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="px-2 py-1.5">
          <p className="font-mono text-[8px] uppercase tracking-[0.2em] text-cream/40">
            {tv.n}
          </p>
          <p className="mt-0.5 truncate font-display text-[11px] font-bold tracking-tight text-cream/85">
            {tv.name}
          </p>
        </div>
      </div>
    ))}
  </div>
);
